import gql from 'graphql-tag'

import Price from '@Queries/cms/fragments/Price.fragment'

export default gql`
  ${Price}

  fragment ProductContent on Product {
    id
    type
    name
    url
    description
    availability {
      isInStock
      quantity
    }
    brand {
      id
      logo
      title
      url
    }
    categoryIDs
    primaryCategories {
      id
      name(locale: "en-GB")
    }
    masterVariant {
      id
      price {
        ...PriceFragment
      }
      basePrice: price(currencyCode: "DKK") {
        plain: format(mode: NUMBER_PLAIN)
        discount {
          plain: format(mode: NUMBER_PLAIN)
        }
      }
      availability {
        isInStock
        quantity
      }
      isVirtual
      attributes {
        ... on IAttribute {
          key
        }
        ... on BaseAttribute {
          value
        }
        ... on MoneyAttribute {
          money {
            ...MoneyContent
          }
        }
      }
    }
    primaryAsset: asset(tag: "primary") {
      url
      tags
    }
    moneyShotAsset: asset(tag: "money_shot") {
      url
      tags
    }
    assets {
      url
      tags
      dimensions {
        width
        height
      }
    }
    variants {
      id
      price {
        ...PriceFragment
      }
      availability {
        isInStock
        quantity
      }
      attributes {
        ... on IAttribute {
          key
        }
        ... on BaseAttribute {
          value
        }
        ... on MoneyAttribute {
          money {
            ...MoneyContent
          }
        }
      }
    }
  }
`
